package com.macrofocus.nastac.components.link

import react.FC
import react.Props
import react.dom.html.ReactHTML.a
import web.window.WindowTarget
import web.window._blank

public val HEGLink = FC<Props> { props ->
    a {
        href = "https://icr.ethz.ch/data/heg/"
        target = WindowTarget._blank
        asDynamic().underline = "hover" // "none" | "hover" | "always"
        +"HEG"
    }
}